import {Box} from 'src/design/atoms/Box';
import type {MRT_ColumnDef} from 'mantine-react-table';
import {useMemo} from 'react';
import type {CourseDefinitionSimpleResponse} from 'src/api/ProactApiClient';
import {Pill} from 'src/design/atoms/Pill';
import {ActiveInactivePills} from 'src/shared/constants/PillConstants';
import {ActiveStateDataOptions} from 'src/shared/constants/columnFilterData';
import {serverComputedColumn} from 'src/design/organisms/serverComputedColumn';

export const useCourseDefinitionColumns = () => {
  const columns = useMemo<MRT_ColumnDef<CourseDefinitionSimpleResponse>[]>(
    () => [
      {
        accessorKey: 'name',
        header: 'Name',
      },
      {
        accessorKey: 'internalIdentifier',
        header: 'Identifier',
      },
      {
        accessorKey: 'creator.name',
        header: 'Created By',
      },
      {
        accessorKey: 'active',
        header: 'Active',
        enableColumnFilterModes: false,
        filterVariant: 'multi-select',
        mantineFilterSelectProps: {
          data: ActiveStateDataOptions,
        },
        Cell: ({cell}) => {
          const cellValue = cell.getValue<boolean>();
          const pillConfig = ActiveInactivePills(cellValue);
          return <Pill text={pillConfig.text} color={pillConfig.color} />;
        },
      },
      {
        accessorKey: 'project.name',
        header: 'Project',
      },
      serverComputedColumn({
        accessorKey: 'assignedCount',
        header: 'Assigned',
      }),
      serverComputedColumn({
        accessorKey: 'completedCount',
        header: 'Completed',
      }),
      serverComputedColumn({
        accessorKey: 'overdueCount',
        header: 'Overdue',
        Cell: ({cell}) => {
          const value = cell.getValue<number>();
          return value > 0 ? <Box c="red">{value}</Box> : value;
        },
      }),
      serverComputedColumn({
        accessorKey: 'completionPercentage',
        header: 'Completion %',
        Cell: ({cell}) => `${Math.round(cell.getValue<number>())}%`,
      }),
    ],
    []
  );

  return columns;
};
